import { useCallback, useState } from 'react';
import Utils from '@/common/utils/utils';
import { Dialog, Popover } from '@material-ui/core';
import { I18n } from 'aws-amplify';
import { ButtonOption, FlagMessageCopyLink } from '@/component/ticketList/DetailTicketList';
import EmailImageAttachment from './EmailImageAttachment';
import EmailOtherAttachment from './EmailOtherAttachment';
import { PropTypes } from 'prop-types';

function EmailAttachmentViewOnly({ fieldData, detailTicket, setIsShowPopupLogout }) {
    const [openPreviewImage, setOpenPreviewImage] = useState(null);
    const [openOption, setOpenOption] = useState(null);
    const [openFileOption, setOpenFileOption] = useState(null);
    const [isShowFlagMessage, setIsShowFlagMessage] = useState(false);

    const onClickCopyShareLink = useCallback(() => {
        const linkUrl = Utils.getShareLinkImg({
            attachFile: openFileOption,
            dataShareLink: detailTicket.dataShareLink
        });

        navigator.clipboard.writeText(linkUrl);
        setIsShowFlagMessage(true);
        setTimeout(() => {
            setIsShowFlagMessage(false);
        }, 3000);
    }, [detailTicket, openFileOption]);

    let fileList = fieldData.value;
    let fileImageList = fileList.filter(item => Utils.isImageFile(item.fileName));
    let otherFileList = fileList.filter(item => !Utils.isImageFile(item.fileName));

    return (
        <div className="lstName-file attach-file-chat-post-list">
            <ul>
                <div style={{ display: 'flex', gap: 15, flexWrap: 'wrap' }}>
                    {fileImageList.map((item, index) => (
                        <EmailImageAttachment
                            key={index}
                            item={item}
                            detailTicket={detailTicket}
                            setOpenPreviewImage={setOpenPreviewImage}
                            setOpenFileOption={setOpenFileOption}
                            setOpenOption={setOpenOption}
                        />
                    ))}
                </div>
                {otherFileList.map((file, index) => (
                    <EmailOtherAttachment
                        key={index}
                        file={file}
                        detailTicket={detailTicket}
                        setIsShowPopupLogout={setIsShowPopupLogout}
                    />
                ))}
            </ul>
            <Popover
                open={Boolean(openOption) || false}
                anchorEl={openOption}
                onClose={() => {
                    setOpenFileOption(null);
                    setOpenOption(null);
                }}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left'
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    {openFileOption?.shortKey && !Utils.isEmptyObject(detailTicket?.dataShareLink) && (
                        <FlagMessageCopyLink
                            title={I18n.get('KNOWDEMSG002')}
                            placement="top-start"
                            arrow={true}
                            open={isShowFlagMessage}
                        >
                            <ButtonOption onClick={onClickCopyShareLink}>
                                <span
                                    style={{
                                        fontSize: 15,
                                        fontWeight: 400,
                                        fontFamily: 'Zen Kaku Gothic New'
                                    }}
                                >
                                    {I18n.get('GET_URL')}
                                </span>
                            </ButtonOption>
                        </FlagMessageCopyLink>
                    )}
                </div>
            </Popover>

            <Dialog
                open={!!openPreviewImage}
                onClose={() => setOpenPreviewImage(null)}
                maxWidth="md"
            >
                <img
                    alt=""
                    src={openPreviewImage}
                    style={{
                        maxWidth: '90vw',
                        maxHeight: '90vh',
                        objectFit: 'contain'
                    }}
                />
            </Dialog>
        </div>
    );
}

EmailAttachmentViewOnly.propTypes = {
    fieldData: PropTypes.any,
    detailTicket: PropTypes.any,
    setIsShowPopupLogout: PropTypes.func
};

export default EmailAttachmentViewOnly;

